import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Optimizechicago() {
  return (
    <section className="leading_miami tekrevol_dark_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Work With The Best Mobile App Developers In San Francisco</h2>
            <p>
              From iterating emerging technologies to leveraging conventional
              technologies to their limits, we’re tech-driven app developers in
              San Francisco that build digital products to introduce a new
              concept in the market. We believe in building new revenue streams
              for organizations that unlock new opportunities. With a
              professional mobile app development team including project
              managers, developers, Q/A specialists, UI/UX designs, and growth
              consultants, we build mobile applications that solves a unique
              problem and engage the maximum users.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your App
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="leading_miami_img">
              <StaticImage
                src="../../images/location_new/san-francisco/work_san.webp"
                alt="app development companies San Francisco"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={415}
                height={705}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimizechicago;
